<template>
    <a-button :loading="isLoading" v-bind="$attrs" @click="handleClick">
        <slot></slot>
    </a-button>
</template>

<script>

// 定义异步函数的构造函数
const AsyncFunction = Object.getPrototypeOf(async function () { }).constructor;

/* 
父组件调用时，@click绑定的事件必须使用async await，或者return一个promise对象，否则会当成普通函数
*/
export default {
    props: {
    },
    data() {
        return {
            // 定义loading状态
            isLoading: false
        };
    },
    methods: {
        async handleClick(event) {
            // 先存储结果，避免同步函数执行两次
            const result = this.$listeners.click();
            // 判断是否为异步函数
            const isAsync = this.$listeners.click instanceof AsyncFunction || (result instanceof Promise);
            if (isAsync) {
                this.isLoading = true;
            }
            try {
                if (isAsync) {
                    await result;
                }
            } catch (error) {
                console.error(error);
            } finally {
                if (isAsync) {
                    this.isLoading = false;
                }
            }
        }
    }
};
</script>

<style scoped></style>